import { json, jsonParseLinter } from "@codemirror/lang-json";
import { linter, lintGutter } from "@codemirror/lint";
import CodeMirror from "@uiw/react-codemirror";

type JsonViewProps = {
  content?: string;
};

export const JsonView = ({ content }: JsonViewProps) => {
  const jsonParseLinterFn = jsonParseLinter();
  const jsonLinter = linter((view) => {
    const errors = jsonParseLinterFn(view);
    return errors;
  });

  return (
    <CodeMirror
      extensions={[json(), jsonLinter, lintGutter()]}
      value={content ? JSON.stringify(JSON.parse(content), null, 2) : undefined}
      theme={"dark"}
      editable={false}
    />
  );
};
